const ProjectCardSkeleton = () => {
    return (
        <div className="bg-surface-bg-primary border border-surface-border rounded-lg p-4">
            <div className="flex items-start justify-between gap-4 animate-pulse">
                <div className="flex items-start gap-3 flex-1">
                    {/* Icon skeleton */}
                    <div className="w-8 h-8 rounded-full bg-surface-bg-secondary flex-shrink-0" />
                    <div className="flex-1 space-y-2">
                        {/* Line 1: Project Name */}
                        <div className="h-4 bg-surface-bg-secondary rounded w-3/4" />
                        {/* Line 2: Goal Count and Hours */}
                        <div className="flex items-center gap-3 flex-wrap">
                            <div className="h-3 bg-surface-bg-secondary rounded w-16" />
                            <div className="h-3 bg-surface-bg-secondary rounded w-12" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectCardSkeleton;
